import { isValidPhoneInput } from "../../utils/phone";

const ALWAYS = [
  { key: "firstName", label: "First name", required: true },
  { key: "lastName", label: "Last name", required: false },
  {
    key: "gender",
    label: "Gender",
    required: true,
    infer: "name",
    options: [
      { value: "M", aliases: ["male", "man", "ذكر"] },
      { value: "F", aliases: ["female", "woman", "أنثى", "انثى"] },
      { value: "O", aliases: ["other"] },
    ],
  },
];

const SETTING_FIELDS = [
  { setting: "middleName", key: "middleName", label: "Middle name", message: "Middle name is required" },
  { setting: "maritalStatus", key: "martialStatus", label: "Marital status", message: "Marital status is required" },
  { setting: "homeAddress", key: "homeAddress", label: "Home address", message: "Home address is required" },
  { setting: "jobTitle", key: "occupation", label: "Job title", message: "Occupation is required" },
  { setting: "companyName", key: "companyName", label: "Company name", message: "Company name is required" },
  { setting: "healthProblem", key: "healthProblem", label: "Health problem", message: "Health problem is required" },
  { setting: "handedness", key: "handedness", label: "Handedness", message: "Handedness is required" },
  { setting: "smokingHabits", key: "smokingHabits", label: "Smoking habits", message: "Smoking habits is required" },
  { setting: "referralSource", key: "referralSource", label: "Referral source", message: "Referral source is required" },
  { setting: "childerNote", key: "childerNote", label: "Children note", message: "Children note is required" },
];

const empty = (value) =>
  value === undefined || value === null || String(value).trim() === "";

export function memberRegistrationSpecs(settings, gymConfig) {
  const registration = (settings && settings.memberRegistration) || {};
  const configured = registration.fields || {};
  const fields = ALWAYS.map((field) => ({ ...field }));
  const groups = [];
  const primary = registration.primaryField || "emailOrPhone";

  if (primary === "emailAndPhone") {
    fields.push({ key: "email", label: "Email", required: true, format: "email", message: "Email address is required" });
    fields.push({ key: "phone", label: "Phone", required: true, format: "internationalPhone", message: "Phone number is required" });
  } else {
    fields.push({ key: "email", label: "Email", required: false, format: "email", message: "Email address is required" });
    fields.push({ key: "phone", label: "Phone", required: false, format: "internationalPhone", message: "Phone number is required" });
    groups.push({
      keys: ["email", "phone"],
      label: "Email or Phone",
      messages: {
        email: "Email address is required",
        phone: "Phone number is required",
      },
    });
  }

  if (registration.profilePictureRequired) {
    fields.push({
      key: "image",
      label: "Profile picture",
      required: true,
      message: "image profile is required",
    });
  }

  SETTING_FIELDS.forEach((field) => {
    const config = configured[field.setting];
    if (!config || !config.enabled) return;
    fields.push({
      key: field.key,
      label: field.label,
      required: Boolean(config.isRequired),
      message: field.message,
    });
  });

  const emergency = configured.emergencyContact;
  if (emergency && emergency.enabled) {
    fields.push({
      key: "emergencyName",
      label: "Emergency name",
      required: Boolean(emergency.isRequired),
      message: "Emergency name is required",
    });
    fields.push({
      key: "emergencyPhone",
      label: "Emergency phone",
      required: Boolean(emergency.isRequired),
      message: "Emergency phone is required",
    });
  }

  if (gymConfig && gymConfig.gates && gymConfig.gates.enabled && gymConfig.gates.accessBy === "RFIDCards") {
    fields.push({
      key: "RFIDCardIdField",
      label: "RFID card",
      required: true,
      message: "RFID card is required",
    });
  }

  return { fields, groups };
}

export function memberFieldErrors(values, settings, gymConfig) {
  const { fields, groups } = memberRegistrationSpecs(settings, gymConfig);
  const errors = {};
  fields.forEach((field) => {
    if (field.key === "firstName" || field.key === "gender" || field.key === "lastName") return;
    if (field.required && empty(values[field.key])) errors[field.key] = field.message;
  });
  groups.forEach((group) => {
    if (group.keys.some((key) => !empty(values[key]))) return;
    group.keys.forEach((key) => {
      errors[key] = group.messages[key];
    });
  });
  if (!empty(values.phone) && !isValidPhoneInput(values.phone, values.country)) {
    errors.phone = "Phone number is not valid";
  }
  return errors;
}
